var path = '/app/pages/bookmarks/bookmarks.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;